import { render } from "./MultiFactor.vue?vue&type=template&id=c83b61f0&scoped=true"
import script from "./MultiFactor.vue?vue&type=script&lang=js"
export * from "./MultiFactor.vue?vue&type=script&lang=js"

import "./login.scss?vue&type=style&index=0&id=c83b61f0&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83b61f0"]])

export default __exports__